import React from "react";
import {Avatar, Typography} from "antd";
import {HealthCheckerIssueUser} from "../../../models/health-checker/health-checker";

const {Text} = Typography;

interface IssueUserProps {
    user: HealthCheckerIssueUser;
}

export const IssueUser: React.FC<IssueUserProps> = ({user}) => {
    const name = `${user.firstName} ${user.lastName}`.trim() || user.email;
    const initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();

    return (
        <div className="health-center-issue__user">
            <Avatar className="health-center-issue__user-avatar">{initials || "?"}</Avatar>
            <div className="health-center-issue__user-details">
                <Text strong>{name}</Text>
                <Text type="secondary">{user.email}</Text>
                <Text type="secondary" className="health-center-issue__user-id">#{user.id}</Text>
            </div>
        </div>
    );
};
